import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { PaymentStatus } from "../../../../../../../../services/Api/Public/types";
import { OrderContext } from "../../../../contexts/OrderContext";
import { OrderActionsSection } from "../OrderActions/OrderActionsSection";

const OrderPaymentSection = () => {
	const { order } = useContext(OrderContext);
	const { t } = useTranslation();
	const isPartiallyPaid =
		order?.to_pay?.amount !== undefined &&
		order.to_pay.amount > 0 &&
		order?.total_price?.amount > order?.to_pay?.amount;

	const shouldRender = order && (order.payment_status === PaymentStatus.PAID || isPartiallyPaid);

	if (!shouldRender) return <></>;

	const transactions = order.transactions || [];

	const getPaymentMethods = () => {
		const paidTransactions = transactions.filter((transaction) => transaction.status === PaymentStatus.PAID);

		return paidTransactions.map((paidTransaction) => paidTransaction.payment_method.name).join(", ");
	};

	const getTransactionStatusInfo = () => {
		if (isPartiallyPaid) {
			return {
				title: t("modules.e_order.field.partially_paid.title"),
				className: "transaction-warning",
			};
		}

		return {
			title: t("modules.e_order.field.paid.title"),
			className: "transaction-success",
		};
	};

	const transactionInfo = getTransactionStatusInfo();

	return (
		<section>
			<h1>{t("modules.e_order.field.payment.title")}</h1>
			<div className="d-flex flex-column gap-1 w-100">
				<div className="row">
					<div className="col-6 text-start">
						<p className="mb-0">{`${t("lib:common.word.status")}:`}</p>
					</div>
					<div className="col-6 text-end">
						<p className={`mb-0 ${transactionInfo.className}`}>{transactionInfo.title}</p>
					</div>
				</div>
				<div className="row">
					<div className="col-6 text-start">
						<p className="mb-0">{`${t("common.word.payment_method")}:`}</p>
					</div>
					<div className="col-6 text-end">
						<p className="mb-0">{getPaymentMethods()}</p>
					</div>
				</div>
				{order.tax_id_no && (
					<div className="row">
						<div className="col-6 text-start">
							<p className="mb-0">{`${t("modules.e_order.field.tax_id_no.title")}:`}</p>
						</div>
						<div className="col-6 text-end">
							<p className="mb-0">{order.tax_id_no}</p>
						</div>
					</div>
				)}
				<div className="mt-2">
					<OrderActionsSection orderNumber={order.number} />
				</div>
			</div>
		</section>
	);
};

export default OrderPaymentSection;
